import { useContext } from 'react'
import { DashboardContext } from '../../context'
import LinksCardContainer from './LinkCardContainer'
import Error404 from '../error/Error404'

export default function DisplayGroups() {
    const dashboardContext = useContext(DashboardContext)
    if (dashboardContext?.navBar.menuSelected) {
        return <LinksCardContainer menu={dashboardContext?.navBar.menuSelected} />
    }
    return <Error404 />
}
